import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-teacher-eligibility-dialog-box',
  templateUrl: './teacher-eligibility-dialog-box.component.html',
  styleUrls: ['./teacher-eligibility-dialog-box.component.scss']
})
export class TeacherEligibilityDialogBoxComponent implements OnInit {
  teacherAssignForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  isread = false;
  isreaddelete = false;
  isEditMode = false;
  APIService: any;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  TeacherEligibilityCreate = true;
  TeacherEligibilityUpdate = true;
  TeacherEligibilityDelete = true;
  userPermission: any;
  facultyList: any = [];
  filteredFacultyList: any = [];
  courseList: any = [];
  filteredCourseList: any = [];
  subjectList: any = [];
  filteredSubjectList: any = [];
  teacherTypeList: any = [];
  filteredTeacherTypeList: any = [];
  courseLevelList: any = [];  
  filteredCourseLevelList: any = [];
  selectedCourseLevel: string = '';  

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    private dialogRef2: MatDialogRef<TeacherEligibilityDialogBoxComponent>,
  ) { 
    this.APIService = environment.serviceUrl; 
  }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission") || '[]');
    
    window.scroll(0, 0);
    this.teacherAssignForm = this.fb.group({
      Faculty: new FormControl('', [Validators.required]),
      CoCode: new FormControl('', [Validators.required]),
      SubId: new FormControl(''),
      Designation: new FormControl('', [Validators.required]),
      Experience: new FormControl('', [Validators.required]),
      Count: new FormControl('', [Validators.required]),
      District: new FormControl('', [Validators.required]),
      Is_Repeat: new FormControl(false),
      TeacherType: new FormControl('', [Validators.required]),
      IsHOD: new FormControl(false),
      IsSameCollege: new FormControl(false),
      IsBothTeachType: new FormControl(false),
      Guide: new FormControl(false),
      CoLevel: new FormControl('', [Validators.required]),
      IsNotSameDistirct: new FormControl(false)
    });

    this.loadFacultyData();
    this.loadTeacherTypeData();
    this.fetchCourseLevel();  
    
    this.submitButton = false;
    this.editButton = false;
    this.deleteButton = false;

    if (this.data.key === 'Add') {
      this.submitButton = true; 
      this.editButton = false;
      this.deleteButton = false;
      this.isread = false;
      this.isreaddelete = false;
      this.teacherAssignForm.reset({
        Faculty: '',
        CoCode: '',
        SubId: '',
        Designation: '',
        Experience: '',
        Count: '',
        District: '',
        Is_Repeat: '',
        TeacherType: '',
        IsHOD: '',
        IsSameCollege: '',
        IsBothTeachType: '',
        Guide:'',
        CoLevel: '',
        IsNotSameDistirct:'',
      });
        this.teacherAssignForm.get('CoLevel')?.disable();

      this.filteredCourseList = [];
      this.filteredSubjectList = [];
    } 
    else if (this.data.key === 'Edit') {
      this.isEditMode = true;
      this.submitButton = false;
      this.editButton = true;
      this.deleteButton = false;
      this.isread = true;
      this.isreaddelete = false;
      this.prepopulation(this.data.selected);
    } 
    else if (this.data.key === 'Delete') {
      this.submitButton = false;
      this.editButton = false;
      this.deleteButton = true;
      this.isread = true;
      this.isreaddelete = true;
      this.prepopulationForDelete(this.data.selected);
    }
  }

 
  fetchCourseLevel() {
    const payload = { CdType: 'COLVL' };
    this.umsService.getCodeType(payload).subscribe(res => {
      if (res.status) {
        this.courseLevelList = res.data;
        this.filteredCourseLevelList = this.courseLevelList.slice();
      }
    }, error => {
      console.error('Error fetching course levels:', error);
    });
  }

  loadFacultyData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.facultyList = res.data;
        this.filteredFacultyList = res.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.facultyList = [];
        this.filteredFacultyList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.facultyList = [];
      this.filteredFacultyList = [];
    });
  }

  loadCourseData(facultyCode: string) {
    this.spinner.show();
    const payload = { FcCode: facultyCode };
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.courseList = res.data;
        this.filteredCourseList = res.data;
      } else {
        this.courseList = [];
        this.filteredCourseList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseList = [];
      this.filteredCourseList = [];
    });
  }

  onFacultyChange() {
    const facultyCode = this.teacherAssignForm.value.Faculty;
    if (facultyCode) {
      this.loadCourseData(facultyCode);
      
      this.teacherAssignForm.patchValue({ 
        CoCode: '', 
        SubId: '',
        CoLevel:  this.isEditMode ? this.teacherAssignForm.value.CoLevel : ''  
      });
      this.filteredSubjectList = [];
      this.selectedCourseLevel = '';
    }
  }

  onCourseChange() {
  const courseCode = this.teacherAssignForm.value.CoCode;

  if (courseCode) {
    this.loadSubjectData(courseCode);

    if (!this.isEditMode) {
      this.teacherAssignForm.patchValue({ SubId: '0' });
    }

    if (!this.isEditMode) {
      const selectedCourse = this.courseList.find(
        course => course.CoCode === courseCode
      );

      if (selectedCourse) {
        this.teacherAssignForm.patchValue({
          CoLevel: selectedCourse.CourseLevel || ''
        });
        this.selectedCourseLevel = selectedCourse.CourseLevel;
      }
    }

  } else {
    this.filteredSubjectList = [];

    if (!this.isEditMode) {
      this.teacherAssignForm.patchValue({
        CoLevel: '',
        SubId: ''
      });
      this.selectedCourseLevel = '';
    }
  }
}


loadSubjectData(CoCode: string) {
  this.spinner.show();

  const payload = { CoCode };

  this.umsService.getCoursewiseSub(payload).subscribe(
    res => {
      this.spinner.hide();

      if (res.status && Array.isArray(res.data)) {
        this.subjectList = res.data.map((s: any) => ({
          SubId: s.EsId + '',
          SubName: s.EsName
        }));
        this.subjectList.unshift({
          SubId: '0',
          SubName: 'All'
        });
        this.filteredSubjectList = [...this.subjectList];

      } else {
        this.subjectList = [];
        this.filteredSubjectList = [];
      }
    },
    error => {
      this.spinner.hide();
      console.error('Error loading subjects:', error);
      this.subjectList = [];
      this.filteredSubjectList = [];
    }
  );
}



  loadTeacherTypeData() {
    this.spinner.show();
    const payload = { CdType: 'TEATY' };
    this.umsService.fetchCodeType(payload).subscribe(res => {
      this.spinner.hide();
      if (res?.status) {
        this.teacherTypeList = res.data;
        this.filteredTeacherTypeList = res.data;
      } else {
        this.teacherTypeList = [];
        this.filteredTeacherTypeList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.teacherTypeList = [];
      this.filteredTeacherTypeList = [];
    });
  }

  prepopulation(selectedRecord: any) {
    this.spinner.show();

    const payload = {
      PageSize: 1,
      PageNumber: 1,
      SearchString: '',
      EligibId: selectedRecord.SrNo
    };

    this.umsService.getTeacherEligibilityData(payload).subscribe(res => {
      if (!res.status || !res.data?.length) {
        this.spinner.hide();
        let alertData = {
          'message': 'Record not found',
          'title': 'Information',
          'icon': 'fas fa-box-open'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, alertData);
        return;
      }

      const data = res.data[0];
      
      this.teacherAssignForm.patchValue({
        Faculty: data.FcCode + ''
      });
      
      this.umsService.getCourse({ FcCode: data.FcCode }).subscribe(courseRes => {
        if (courseRes.status) {
          this.filteredCourseList = courseRes.data;

        this.teacherAssignForm.patchValue({
            CoCode: data.CoCode + ''
          });

          this.loadSubjectData(data.CoCode); 

          setTimeout(() => {
            this.teacherAssignForm.patchValue({
              SubId: data.SubId ? data.SubId + '' : '0'
            });
          }, 0);

          this.umsService.getCoursewiseSub({ CoCode: data.CoCode }).subscribe(subRes => {
            if (subRes.status) {
              this.filteredSubjectList = subRes.data || [];

              if (data.SubId === "0") {
                const allExists = this.filteredSubjectList.find(s => s.SubId === "0");
                if (!allExists) {
                  this.filteredSubjectList.unshift({ SubId: "0", SubName: "All" });
                }
              }

              this.teacherAssignForm.patchValue({
                SubId: data.SubId + ''
              });
            }

            this.teacherAssignForm.patchValue({
              Designation: data.Designation,
              Experience: data.Experience,
              Count: data.Count,
              District: data.District,
              Is_Repeat: data.Is_Repeat === true || data.Is_Repeat === 1,
              TeacherType: data.TeacherType,
              IsHOD: data.IsHOD === 1,
              IsSameCollege: data.IsSameCollege === 1,
              IsBothTeachType: data.IsBothTeachType === 1,
              Guide: data.Guide === 1,
             CoLevel: data.CourseLevel || '' ,
             IsNotSameDistirct: data.IsNotSameDistirct ==1,
            });
    
            this.selectedCourseLevel = data.CourseLevel;
            
            this.spinner.hide();
          }, subError => {
            this.spinner.hide();
          });
        } else {
          this.spinner.hide();
        }
      }, courseError => {
        this.spinner.hide();
      });
    }, error => {
      this.spinner.hide();
    });
  }

  prepopulationForDelete(selectedRecord: any) {
    this.spinner.show();
    const payload = {
      PageSize: 1,
      PageNumber: 1,
      SearchString: '',
      EligibId: selectedRecord.SrNo || 0
    };

    this.umsService.getTeacherEligibilityData(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status && res.data && res.data.length > 0) {
        const data = res.data[0];
        
        this.editButton = false;
        this.submitButton = false;
        this.isreaddelete = true;
        this.deleteButton = true;
        this.isread = true;
        

        this.loadCourseData(data.FcCode);
        this.loadSubjectData(data.CoCode);
        
       
        this.teacherAssignForm.patchValue({
          Faculty: data.FcCode,
          CoCode: data.CoCode,
          SubId: data.SubId === "0" ? "0" : data.SubId || '',
          Designation: data.Designation,
          Experience: data.Experience,
          Count: data.Count,
          District: data.District,
          Is_Repeat: data.Is_Repeat === 1 || data.Is_Repeat === true,
          TeacherType: data.TeacherType,
          IsHOD: data.IsHOD === 1,
          IsSameCollege: data.IsSameCollege === 1,
          IsBothTeachType: data.IsBothTeachType === 1,
          Guide: data.Guide === 1,
          CoLevel: data.CourseLevel || ''  ,
          IsNotSameDistirct: data.IsNotSameDistirct ===1,
        });
        
        this.selectedCourseLevel = data.CourseLevel;
        
        Object.keys(this.teacherAssignForm.controls).forEach(key => {
          this.teacherAssignForm.get(key)?.disable();
        });
        
      } else {
        let alertData = {
          'message': res.message || 'Record not found',
          'title': 'Information',
          'icon': 'fas fa-box-open'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, alertData);
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef2.close();
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let alertData = {
        'message': ERROR.error?.message || 'Error fetching record',
        'title': 'Alert',
        'icon': 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, alertData);
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef2.close();
      });
    });
  }

  DeletetheRecord() {
   const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.teacherAssignForm.value);
        // this.dialogRef2.close();
      } else {
        // this.dialogRef2.close();
      }
    });
  }

  deletedata(id: any) {
   this.spinner.show();
    this.submitpayload = this.teacherAssignForm.value;
    this.submitpayload.SrNo = this.data.selected.SrNo;
    this.submitpayload.Is_Repeat = this.submitpayload.Is_Repeat ? 1 : 0;
    this.submitpayload.IsHOD = this.submitpayload.IsHOD ? 1 : 0;
    this.submitpayload.IsSameCollege = this.submitpayload.IsSameCollege ? 1 : 0;
    this.submitpayload.IsBothTeachType = this.submitpayload.IsBothTeachType ? 1 : 0;
    this.submitpayload.Guide = this.submitpayload.Guide ? 1 : 0;
    this.submitpayload.SubId = this.submitpayload.SubId || 0;
    this.submitpayload.IsNotSameDistirct = this.submitpayload.IsNotSameDistirct ? 1 : 0;
   
    if (!this.submitpayload.CoLevel && this.selectedCourseLevel) {
      this.submitpayload.CoLevel = this.selectedCourseLevel;
    }
    
    this.umsService.deleteTeacherEligibility(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {
          'message': res.message,
          'title': 'Information',
          'icon': 'fas fa-check'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef2.close(true);
        });
      } else {
        let data = {
          'message': res.message,
          'title': 'Information',
          'icon': 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {
        'message': ERROR.error?.message || 'Error deleteing record',
        'title': 'Information',
        'icon': 'fas fa-box-open'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  submit() {
    if (this.teacherAssignForm.invalid) {
      this.markAllFormControlsAsTouched();
      return;
    } else {
      this.addTeacherEligibility();
    }
  }

  markAllFormControlsAsTouched() {
    const controls = this.teacherAssignForm.controls;
    Object.keys(controls).forEach(key => {
      const control = controls[key];
      control.markAsTouched();
    });
  }

  addTeacherEligibility() {
    this.spinner.show();
    this.submitpayload = this.teacherAssignForm.value;
    
    this.submitpayload.Is_Repeat = this.submitpayload.Is_Repeat ? 1 : 0;
    this.submitpayload.IsHOD = this.submitpayload.IsHOD ? 1 : 0;
    this.submitpayload.IsSameCollege = this.submitpayload.IsSameCollege ? 1 : 0;
    this.submitpayload.IsBothTeachType = this.submitpayload.IsBothTeachType ? 1 : 0;
    this.submitpayload.Guide = this.submitpayload.Guide ? 1 : 0;
    this.submitpayload.SubId = this.submitpayload.SubId || 0;
    this.submitpayload.IsNotSameDistirct = this.submitpayload.IsNotSameDistirct ? 1 : 0;
    

    if (!this.submitpayload.CoLevel && this.selectedCourseLevel) {
      this.submitpayload.CoLevel = this.selectedCourseLevel;
    }
    
    this.umsService.addNewRecord(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {
          'message': res.message,
          'title': 'Information',
          'icon': 'fas fa-check'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef2.close(true);
        });
      } else {
        let data = {
          'message': res.message,
          'title': 'Information',
          'icon': 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {
        'message': ERROR.error?.message || 'Error adding record',
        'title': 'Information',
        'icon': 'fas fa-box-open'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  update() {
    if (this.teacherAssignForm.invalid) {
      this.markAllFormControlsAsTouched();
      return;
    } else {
      this.updateTeacherEligibility();
    }
  }

  updateTeacherEligibility() {
    this.spinner.show();
    this.submitpayload = this.teacherAssignForm.value;
    this.submitpayload.SrNo = this.data.selected.SrNo;
    this.submitpayload.Is_Repeat = this.submitpayload.Is_Repeat ? 1 : 0;
    this.submitpayload.IsHOD = this.submitpayload.IsHOD ? 1 : 0;
    this.submitpayload.IsSameCollege = this.submitpayload.IsSameCollege ? 1 : 0;
    this.submitpayload.IsBothTeachType = this.submitpayload.IsBothTeachType ? 1 : 0;
    this.submitpayload.Guide = this.submitpayload.Guide ? 1 : 0;
    this.submitpayload.SubId = this.submitpayload.SubId || 0;
    this.submitpayload.IsNotSameDistirct = this.submitpayload.IsNotSameDistirct ? 1 : 0;
   
    if (!this.submitpayload.CoLevel && this.selectedCourseLevel) {
      this.submitpayload.CoLevel = this.selectedCourseLevel;
    }
    
    this.umsService.editTeacherEligibility(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {
          'message': res.message,
          'title': 'Information',
          'icon': 'fas fa-check'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef2.close(true);
        });
      } else {
        let data = {
          'message': res.message,
          'title': 'Information',
          'icon': 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {
        'message': ERROR.error?.message || 'Error updating record',
        'title': 'Information',
        'icon': 'fas fa-box-open'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  closeDialog(): void {
    this.dialogRef2.close();
  }

  deleteRecord() {
    this.DeletetheRecord();
  }
}